import * as React from 'react';

import styles from './Footer.scss';
import { Logo } from 'components/catalogs/components/Logo/Logo';

type Props = {
  catalogCode: string;
  categories: Category[] | null;
  hasError: boolean;
};

type Category = {
  code: string;
  name: string;
};

const toCatalogCategoryPath = (catalogCode: string, categoryCode: string): string =>
  `/catalogs/${encodeURIComponent(catalogCode)}/categories/${encodeURIComponent(categoryCode)}`;

export const Footer = ({ catalogCode, categories, hasError }: Props): JSX.Element => {
  const safeCategories = categories ?? [];
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.logoArea}>
          <Logo
            catalogCode={catalogCode}
            variant="footer"
          />
        </div>

        {!hasError && safeCategories.length > 0 && (
          <nav aria-label="カテゴリ">
            <ul className={styles.categoryList}>
              {safeCategories.map((category) => (
                <li
                  key={category.code}
                  className={styles.categoryItem}
                >
                  <a
                    className={styles.categoryLink}
                    href={toCatalogCategoryPath(catalogCode, category.code)}
                  >
                    {category.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        )}

        <div className={styles.copyright}>
          <p className={styles.copyrightText}>ネットでギフトを贈るなら | TANP（タンプ）</p>
          <p className={styles.copyrightText}>Copyright© TANP Inc.</p>
        </div>
      </div>
    </footer>
  );
};
